module.exports = __webpack_public_path__ + "img/ng1-1.4fb02111.jpg";